(function () {
  var LOG = '[M2L 3D Logo]';

  // Temporary on-screen debug panel for diagnosing the 3D logo on devices
  // without easy devtools access (e.g. mobile/iPad Safari). Only renders
  // when ?m2ldebug is present in the URL - invisible to normal visitors.
  var DEBUG_VISIBLE = /m2ldebug/.test(window.location.search);
  var debugPanel = null;
  function ensurePanel() {
    if (debugPanel || !DEBUG_VISIBLE) return;
    debugPanel = document.createElement('div');
    debugPanel.id = 'm2lDebugPanel';
    debugPanel.style.cssText = 'position:fixed;bottom:0;left:0;right:0;max-height:60vh;overflow:auto;' +
      'background:rgba(0,0,0,0.92);color:#7CFC00;font:11px/1.4 monospace;padding:10px;z-index:999999;' +
      'white-space:pre-wrap;word-break:break-all;';
    document.body.appendChild(debugPanel);
  }
  function panelWrite(kind, args) {
    if (!DEBUG_VISIBLE) return;
    ensurePanel();
    var line = document.createElement('div');
    line.style.color = kind === 'ERROR' ? '#ff5c5c' : '#7CFC00';
    var text = Array.prototype.slice.call(args).map(function (a) {
      if (a && typeof a === 'object') {
        try { return JSON.stringify(a); } catch (e) { return String(a); }
      }
      return String(a);
    }).join(' ');
    line.textContent = '[' + kind + '] ' + text;
    debugPanel.appendChild(line);
    debugPanel.scrollTop = debugPanel.scrollHeight;
  }
  function dlog() {
    console.log.apply(console, [LOG].concat(Array.prototype.slice.call(arguments)));
    panelWrite('LOG', arguments);
  }
  function derr() {
    console.error.apply(console, [LOG].concat(Array.prototype.slice.call(arguments)));
    panelWrite('ERROR', arguments);
  }

  var container = document.getElementById('m2lHeroVisual');
  var canvas = document.getElementById('m2l-logo-canvas');
  var fallbackImg = document.getElementById('m2lHeroLogoImg');

  if (!container || !canvas || !fallbackImg) {
    derr('Required DOM elements missing.', {
      container: !!container, canvas: !!canvas, fallbackImg: !!fallbackImg
    });
    return;
  }

  var modelUrl = canvas.getAttribute('data-model');
  dlog('GLB path resolved to:', modelUrl);
  if (!modelUrl) {
    derr('No data-model attribute on canvas - aborting, static logo stays visible.');
    return;
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  dlog('reducedMotion:', reducedMotion, '| WebGL ctor present:', !!window.WebGLRenderingContext);

  if (reducedMotion) {
    dlog('Skipping 3D by design (reduced-motion) - static logo image stays visible.');
    return;
  }

  dlog('Reading three.js + GLTFLoader from window.THREE (classic bundled script, no ES modules)...');
  var THREE = window.THREE;
  if (!THREE) {
    derr('window.THREE missing - m2l-three-bundle.min.js did not load or run before this script.');
    return;
  }
  dlog('three.js bundle found. Revision:', THREE.REVISION);
  var GLTFLoader = THREE.GLTFLoader;
  if (!GLTFLoader) {
    derr('GLTFLoader missing from window.THREE. Keys:', Object.keys(THREE));
    return;
  }
  dlog('GLTFLoader found on window.THREE.');
  init(THREE, GLTFLoader);

  function init(THREE, GLTFLoader) {
    var rect = container.getBoundingClientRect();
    dlog('Container size at init:', rect.width, 'x', rect.height);
    if (!rect.width || !rect.height) {
      derr('Container has zero size - would render invisible. Aborting, static logo stays.');
      return;
    }

    var renderer, scene, camera, pivot, clock, probeCube;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
      dlog('WebGLRenderer created. GL context present:', !!renderer.getContext());
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      if ('outputColorSpace' in renderer) renderer.outputColorSpace = THREE.SRGBColorSpace;

      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(35, rect.width / rect.height, 0.1, 100);
      camera.position.set(0, 0, 6);

      var ambient = new THREE.AmbientLight(0xffffff, 1.0);
      var key = new THREE.DirectionalLight(0xbcd4ff, 2.2);
      key.position.set(3, 4, 5);
      var rim = new THREE.DirectionalLight(0x4f7dff, 2.6);
      rim.position.set(-4, -2, -3);
      var fillLight = new THREE.PointLight(0x6f9bff, 1.6, 20);
      fillLight.position.set(0, 0, 4);
      scene.add(ambient, key, rim, fillLight);
      dlog('Lights added to scene:', scene.children.filter(function (c) { return c.isLight; }).length);

      pivot = new THREE.Group();
      scene.add(pivot);

      // Diagnostic placeholder: visible immediately, before the GLB even
      // starts loading. If this never appears on screen, the bug is in
      // the renderer/canvas/scene setup, not the GLB file or its material.
      var probeGeo = new THREE.BoxGeometry(2, 2, 2);
      var probeMat = new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true });
      probeCube = new THREE.Mesh(probeGeo, probeMat);
      probeCube.name = 'm2l-debug-probe-cube';
      pivot.add(probeCube);

      renderer.setSize(rect.width, rect.height, false);
      renderer.render(scene, camera);
      container.classList.add('is-3d-active');
      dlog('Probe cube rendered and canvas revealed. If you see a red wireframe cube now, the render pipeline works.');
    } catch (setupErr) {
      derr('WebGL/scene setup threw - falling back to static logo. Full error:', setupErr && setupErr.message ? setupErr.message : setupErr);
      container.classList.remove('is-3d-active');
      return;
    }

    dlog('GLB load started:', modelUrl);
    var loader = new GLTFLoader();
    loader.load(
      modelUrl,
      function (gltf) {
        dlog('GLB load succeeded.');
        try {
          pivot.remove(probeCube);

          var model = gltf.scene;
          var meshCount = 0;
          model.traverse(function (node) {
            if (!node.isMesh) return;
            meshCount++;
            node.material = new THREE.MeshPhysicalMaterial({
              color: new THREE.Color(0x3a7bff),
              emissive: new THREE.Color(0x1c4fe0),
              emissiveIntensity: 1.4,
              metalness: 0.1,
              roughness: 0.25,
              transmission: 0.0,
              thickness: 0.0,
              ior: 1.45,
              clearcoat: 0.3,
              clearcoatRoughness: 0.2,
              envMapIntensity: 1.4,
              side: THREE.DoubleSide
            });
          });
          dlog('Meshes found in GLB and re-materialed:', meshCount);

          if (meshCount === 0) {
            derr('GLB parsed but contains zero meshes - nothing to render. Falling back to static logo.');
            container.classList.remove('is-3d-active');
            return;
          }

          var box = new THREE.Box3().setFromObject(model);
          var size = new THREE.Vector3();
          var center = new THREE.Vector3();
          box.getSize(size);
          box.getCenter(center);
          dlog('Model bounding box size:', size.toArray(), 'center:', center.toArray());

          // Center in an unscaled wrapper FIRST, then scale the wrapper.
          // Centering and scaling the same object directly is order-dependent:
          // position is parent-space translation and is never affected by the
          // object's own scale, so subtracting an unscaled center and then
          // scaling shrinks the mesh's internal offset without shrinking the
          // correction - leaving the model translated far outside the camera
          // frustum even though every load/material step succeeds silently.
          var centered = new THREE.Group();
          centered.add(model);
          model.position.sub(center);

          var maxDim = Math.max(size.x, size.y, size.z) || 1;
          centered.scale.setScalar(2.9 / maxDim);

          pivot.add(centered);

          var verifyBox = new THREE.Box3().setFromObject(pivot);
          var verifyCenter = new THREE.Vector3();
          verifyBox.getCenter(verifyCenter);
          dlog('Post-fit pivot bounding box:', verifyBox.min.toArray(), verifyBox.max.toArray(), 'center:', verifyCenter.toArray());

          dlog('Model added to pivot. Canvas should now show the M2L logo mark.');
          startRender();
        } catch (postErr) {
          derr('Post-load model setup threw. Falling back to static logo. Full error:', postErr && postErr.message ? postErr.message : postErr);
          container.classList.remove('is-3d-active');
        }
      },
      function (progressEvent) {
        if (progressEvent && progressEvent.total) {
          dlog('GLB download progress:', Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%');
        }
      },
      function (loadErr) {
        derr('GLB load FAILED. Falling back to static logo. Full error:', loadErr && loadErr.message ? loadErr.message : loadErr);
        container.classList.remove('is-3d-active');
      }
    );

    function resize() {
      var r = container.getBoundingClientRect();
      if (!r.width || !r.height) return;
      renderer.setSize(r.width, r.height, false);
      camera.aspect = r.width / r.height;
      camera.updateProjectionMatrix();
    }

    var pointer = { x: 0, y: 0 };
    var tilt = { x: 0, y: 0 };
    function onPointerMove(e) {
      var r = container.getBoundingClientRect();
      var relX = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
      var relY = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
      pointer.x = Math.max(-1, Math.min(1, relX));
      pointer.y = Math.max(-1, Math.min(1, relY));
    }

    var started = false;
    function startRender() {
      if (started) return;
      started = true;
      clock = new THREE.Clock();
      resize();
      window.addEventListener('resize', resize);
      window.addEventListener('mousemove', onPointerMove);
      animate();
    }

    function animate() {
      requestAnimationFrame(animate);
      var dt = clock.getDelta();
      pivot.rotation.y += dt * 0.35;
      tilt.x += (pointer.y * 0.25 - tilt.x) * 0.06;
      tilt.y += (pointer.x * 0.35 - tilt.y) * 0.06;
      pivot.rotation.x = tilt.x;
      pivot.rotation.z = -tilt.y * 0.3;
      renderer.render(scene, camera);
    }
  }
})();
